// src/contexts/i18n.tsx
import { createContext, useContext } from "react";
var I18nContext = createContext(null);
var I18nProvider = I18nContext.Provider;
function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx)
    return { text: {} };
  return ctx;
}

export {
  I18nProvider,
  useI18n
};
